import React from 'react'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

type FloorNumberAdditionalProps = {
  className?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}
const FloorNumberField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult> & FloorNumberAdditionalProps> = ({
  className,
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  return (
    <TextInput
      id='floor'
      propertyName='floor'
      className={className}
      placeholder=''
      value={insertionData.floor}
      type='tel'
      maxLength={3}
      errors={validationMessages?.floor ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default FloorNumberField
